<template>
  <div>
    <!-- dialog -->
    <v-dialog
      v-model="dialog"
      max-width="500px"
      @click:outside="close"
      @keydown.esc="close"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Modifier {{ getModelLabel(model) }}</span>
        </v-card-title>
        <v-alert
          v-model="isAlertVisible"
          color="error"
          text
          transition="slide-y-transition"
        >
          {{ message }}
        </v-alert>
        <v-form
          ref="form"
          @submit.prevent="submitForm"
        >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-text-field
                    v-model="item.label"
                    type="text"
                    label="Libellé"
                    :rules="[rules.label]"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-text-field
                    v-model="item.code"
                    readonly
                    type="text"
                    label="Code"
                    :rules="[rules.code]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="12"
                >
                  <v-row class="justify-content-center">
                    <v-color-picker
                      v-model="item.color"
                      mode="hexa"
                      :rules="[rules.color]"
                      width="450"
                    >
                    </v-color-picker>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              outlined
              @click="close"
            >
              Annuler
            </v-btn>
            <v-btn
              :disabled="isDialogVisible"
              :loading="isDialogVisible"
              color="success"
              type="submit"
            >
              Modifier
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  computed, getCurrentInstance, ref, watch,
} from '@vue/composition-api'
import { mdiCalendar, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { notify } from '@core/dynamicComponents/dynamicComponents'
import store from '@/store'

export default {
  name: 'StatusForm',

  model: {
    prop: 'object',
    event: 'update:object',
  },

  emits: ['clickout', 'submitted'],

  props: {
    // eslint-disable-next-line vue/require-default-prop,vue/require-prop-type-constructor
    dialog: {
      type: Boolean,
      default: false,
    },
    model: {
      type: String,
      default: null,
    },
    // eslint-disable-next-line vue/require-default-prop
    object: {
      type: Object,
      default: () => {},
    },
  },

  setup(props, { emit }) {
    const isPasswordVisible = ref(false)
    const isPasswordConfirmationVisible = ref(false)
    const date = ref(null)
    const menu = ref(false)
    const color = ref(null)
    const picker = ref(null)
    const menuref = ref(null)
    const form = ref(null)
    const message = ref('')
    const isDialogVisible = ref(false)
    const errors = ref('')
    const isAlertVisible = ref(false)
    const rules = {
      label: true,
      code: true,
      color: true,
    }

    const getModelLabel = model => {
      switch (model) {
        case 'status':
          return 'statut'
        case 'recType':
          return 'type de recouvrement'
        default:
          return 'Motif de paiement'
      }
    }

    const item = computed({
      get: () => props.object,
      set: value => emit('update:object', value),
    })

    const instance = getCurrentInstance()

    const close = () => {
      isAlertVisible.value = false
      message.value = ''
      rules.code = true
      rules.label = true
      rules.color = true
      instance.emit('clickout')
    }

    watch(() => props.dialog, dialog => {
      // eslint-disable-next-line no-unused-expressions
      dialog || close()
    })

    const submitForm = () => {
      isAlertVisible.value = false
      isDialogVisible.value = true
      if (item.value.color instanceof Object)
        item.value.color = item.value.color.hexa
      switch (props.model) {
        case 'status':
          store.dispatch('status/updateStatus', item.value).then(response => {
            isDialogVisible.value = false
            notify(true, true, response.message)
            close()
          }).catch(error => {
            form.value.validate()
            message.value = error.response.data.message
            errors.value = error.response.data.errors
            if (error.response.data.errors !== undefined) {
              rules.label = error.response.data.errors.label !== undefined ? error.response.data.errors.label[0] : true
              rules.code = error.response.data.errors.code !== undefined ? error.response.data.errors.code[0] : true
              rules.color = error.response.data.errors.color !== undefined ? error.response.data.errors.color[0] : true
            }
            isDialogVisible.value = false
            isAlertVisible.value = true
          })
          break
        case 'recType':
          store.dispatch('recType/updateRecType', item.value).then(response => {
            isDialogVisible.value = false
            notify(true, true, response.message)
            close()
          }).catch(error => {
            form.value.validate()
            message.value = error.response.data.message
            errors.value = error.response.data.errors
            if (error.response.data.errors !== undefined) {
              rules.label = error.response.data.errors.label !== undefined ? error.response.data.errors.label[0] : true
              rules.code = error.response.data.errors.code !== undefined ? error.response.data.errors.code[0] : true
              rules.color = error.response.data.errors.color !== undefined ? error.response.data.errors.color[0] : true
            }
            isDialogVisible.value = false
            isAlertVisible.value = true
          })
          break
        default:
          store.dispatch('payReason/updatePayReason', item.value).then(response => {
            isDialogVisible.value = false
            notify(true, true, response.message)
            close()
          }).catch(error => {
            form.value.validate()
            message.value = error.response.data.message
            errors.value = error.response.data.errors
            if (error.response.data.errors !== undefined) {
              rules.label = error.response.data.errors.label !== undefined ? error.response.data.errors.label[0] : true
              rules.code = error.response.data.errors.code !== undefined ? error.response.data.errors.code[0] : true
              rules.color = error.response.data.errors.color !== undefined ? error.response.data.errors.color[0] : true
            }
            isDialogVisible.value = false
            isAlertVisible.value = true
          })
      }
    }

    return {
      close,
      isPasswordVisible,
      isPasswordConfirmationVisible,
      isAlertVisible,
      isDialogVisible,
      message,
      rules,
      submitForm,
      form,
      date,
      menu,
      picker,
      menuref,
      item,
      color,
      getModelLabel,

      // icons
      icons: {
        mdiCalendar, mdiEyeOutline, mdiEyeOffOutline,
      },
    }
  },
}
</script>

<style scoped>

</style>
